import { render, staticRenderFns } from "./DateWrapper.vue?vue&type=template&id=2dec9bea&scoped=true&"
import script from "./DateWrapper.vue?vue&type=script&lang=js&"
export * from "./DateWrapper.vue?vue&type=script&lang=js&"
import style0 from "./DateWrapper.vue?vue&type=style&index=0&id=2dec9bea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec9bea",
  null
  
)

export default component.exports